<template>
  <div class="wrapper-content w-100">
    <h1>{{title}}</h1>
    <form autocomplete="off" id="form">
      <LmComponentLoading v-if="isLoading" fixed />
      <LmBreadcrumb v-if="showBreadcrumb" />
      <h4 v-if="isOnEditMode">Para el expediente: {{form.numeroExpediente}}</h4>
      <div v-if="!isOnEditMode || form.version === 'mesa3'">
        <h4>Datos del iniciador</h4>
        <input autocomplete="false" name="hidden" type="text" style="display:none;">
        <div class="row">
          <div class="col-12 col-lg-6">
            <LmSelect
              v-model="form.tipoIniciador"
              :v="$v.form.tipoIniciador"
              :options="tiposIniciadores"
              label="Tipo Iniciador"
              :disabled="isOnEditMode"
              @input="updateTipoIniciador"
              />
          </div>
        </div>
        <div v-if="form.codigoTipoIniciador==='PERS'">
          <div class="row">
            <div class="col-12 col-lg-6">
              <LmTextInput
                v-if="isOnEditMode"
                v-model="form.tipoDocumento"
                label="Tipo Documento"
                placeholder="Tipo Documento"
                :disabled="isOnEditMode"
                />
              <LmSuperPowerSelect
                v-else
                :data="tiposDocumentosSelectOptions"
                :tbColumns="lmsuperpowerselectTbColumnsTipoDocumento"
                label="Tipo Documento"
                title="Tipo Documento"
                :v="$v.form.tipoDocumento"
                :model="sanitizeModel(form.idTipoDocumento)"
                @values="updateTipoDocumento"
                :disabled="isOnEditMode"
              />
            </div>
            <div class="col-12 col-lg-5">
              <LmNumberInput
                v-model="form.numero"
                :v="$v.form.numero"
                label="Número de Documento (solo números)"
                placeholder="Número de Documento"
                :disabled="isOnEditMode"
                />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <LmTextInput
                v-model="form.nombre"
                :v="$v.form.nombre"
                label="Nombre"
                placeholder="Nombre"
                :disabled="isOnEditMode"
                :maxLength=21
                />
            </div>
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col-12 col-lg-10">
                  <LmTextInput
                    v-model="form.apellido"
                    :v="$v.form.apellido"
                    label="Apellido"
                    placeholder="Apellido"
                    :disabled="isOnEditMode"
                    :maxLength=35
                    />
                </div>
                <div>
                  <div class="form-check">
                    <input
                      v-model="form.otros"
                      type="checkbox"
                      class="form-check-input"
                      id="otros"
                      :disabled="isOnEditMode"
                      >
                    <label class="form-check-label" for="yOtro">Y Otros</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <LmEmailInput
                v-model="form.emailIniciador"
                :v="$v.form.emailIniciador"
                label="Email"
                placeholder="Email"
                :disabled="isOnEditMode"
                />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <LmGooglePlacesAutocomplete
                label="Direccion"
                @placeChanged="placeChanged"
                @inputLmGooglePlacesAutocomplete="inputLmGooglePlacesAutocomplete"
                :disabled="isOnEditMode"
                :value="form.direccionIniciador.formattedAddress"
                :v="$v.form.direccionIniciador.formattedAddress"
              />
              <LmLeaFletMap
                :markerLatLng="markerLatLng"
                :centerMapCoordinate="markerLatLng"
                class="mb-3"
                />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <LmTextInput
                v-model="form.pisoIniciador"
                :v="$v.form.pisoIniciador"
                label="Piso"
                placeholder="Piso del iniciador"
                :disabled="isOnEditMode"
                :maxLength=3
                />
            </div>
            <div class="col-12 col-lg-5">
              <LmTextInput
                v-model="form.departamentoIniciador"
                :v="$v.form.departamentoIniciador"
                label="Departamento"
                placeholder="Departamento del iniciador"
                :disabled="isOnEditMode"
                :maxLength=3
                />
            </div>
          </div>
          <div class="row">
            <div v-if="isOnEditMode" class="col-12 col-lg-4">
              <LmTextInput
                v-model="form.numeroCuenta"
                :v="$v.form.numeroCuenta"
                label="Cuenta"
                placeholder="Número de cuenta"
                :disabled="isOnEditMode"
                />
            </div>
            <div v-else class="col-12 col-lg-4">
              <LmTextInputGroup
                v-model="form.numeroCuentaBuscar"
                :v="$v.form.numeroCuentaBuscar"
                label="Ingrese el Número de Cuenta a buscar"
                icon="search"
                placeholder="Ingrese el Número de Cuenta a buscar"
                :disabled="isOnEditMode"
                />
            </div>
            <div class="col-12 col-lg-7">
              <LmSuperPowerSelect
                :data="cuentasAsociadasSelectOptions"
                :tbColumns="lmsuperpowerselectTbColumnsCuentas"
                label="Seleccione la Cuenta a vincular"
                title="Seleccione la Cuenta a vincular"
                placeholder="Seleccione la Cuenta a vincular"
                :v="$v.form.numeroCuentaSeleccionado"
                @values="updateCuentaAsociada"
                :model="form.numeroCuentaSeleccionado"
                :disabled="!form.numeroCuentaBuscar || isOnEditMode"
              />
            </div>
          </div>
        </div>
        <div v-if="form.codigoTipoIniciador==='COME'">
          <div class="row">
            <div class="col-12 col-lg-6">
              <LmSuperPowerSelect
                v-if="!isOnEditMode"
                :data="tiposSociedadesSelectOptions"
                :tbColumns="lmsuperpowerselectTbColumnsTipoTramite"
                label="Tipo Sociedad"
                title="Tipo Sociedad"
                :v="$v.form.tipoSociedad"
                :model="form.tipoSociedad"
                @values="updateTipoSociedad"
                :disabled="isOnEditMode"
              />
              <LmTextInput v-else
                v-model="form.tipoSociedad"
                label="Tipo Sociedad"
                placeholder="Tipo Sociedad"
                :disabled="isOnEditMode"
                />
            </div>
            <div class="col-12 col-lg-6">
              <LmTextInput
                v-model="form.razonSocial"
                :v="$v.form.razonSocial"
                label="Razón Social"
                placeholder="Razón Social"
                :disabled="isOnEditMode"
                :maxLength=35
                />
            </div>
          </div>
          <div v-if="form.tipoSociedad==='SH'">
            <hr>
            <h5>Integrantes de la Sociedad de Hecho</h5>
            <div v-for="(field, index) in form.integrantesSH" :key="index" class="bloque-integrantes">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <LmSelect
                    v-model="form.integrantesSH[index].tipoDocumentoSH"
                    :v="$v.form.tipoDocumentoSH"
                    :options="tipoDocumentos"
                    label="Tipo Documento"
                    :disabled="isOnEditMode"
                    />
                </div>
                <div class="col-12 col-lg-5">
                  <LmTextInput
                    v-model="form.integrantesSH[index].numeroDocumentoSH"
                    :v="$v.form.numeroDocumentoSH"
                    label="Número Documento"
                    placeholder="Número Documento"
                    :disabled="isOnEditMode"
                    />
                </div>
                <div class="col-12 col-lg-1">
                  <div v-if="index>0">
                    <LmButton
                      id="btn-borrar-integrantes-sh"
                      type="button"
                      buttonClass="btn-secondary"
                      value="X"
                      @click.native="borrarIntegrantesSH(index, form.integrantesSH)"
                      lmButtonRootWrapperClass="d-inline-block"
                      lmButtonWrapperClass="col"
                      :disabled="isOnEditMode"
                      />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-6">
                  <LmTextInput
                    v-model="form.integrantesSH[index].nombreSH"
                    :v="$v.form.nombreSH"
                    label="Nombre"
                    placeholder="Nombre"
                    :disabled="isOnEditMode"
                    />
                </div>
                <div class="col-12 col-lg-6">
                  <LmTextInput
                    v-model="form.integrantesSH[index].apellidoSH"
                    :v="$v.form.apellidoSH"
                    label="Apellido"
                    placeholder="Apellido"
                    :disabled="isOnEditMode"
                    />
                </div>
                <div class="col-12 col-lg-1">
                </div>
              </div>
            </div>
            <LmButton
              id="btn-agregar-integrante-sh"
              type="button"
              buttonClass="btn-secondary"
              value="Agregar Integrante"
              @click.native="agregarIntegrante"
              lmButtonRootWrapperClass="d-inline-block"
              lmButtonWrapperClass="col"
              :disabled="isOnEditMode"
              />
            <hr>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <LmNumberInput
                v-model="form.cuit"
                :v="$v.form.cuit"
                label="CUIT (solo números)"
                placeholder="CUIT"
                :disabled="isOnEditMode"
                />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <LmEmailInput
                v-model="form.emailIniciador"
                :v="$v.form.emailIniciador"
                label="Email"
                placeholder="Email"
                :disabled="isOnEditMode"
                :maxLength=2
                />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <LmGooglePlacesAutocomplete
                label="Direccion"
                @placeChanged="placeChanged"
                @inputLmGooglePlacesAutocomplete="inputLmGooglePlacesAutocomplete"
                :disabled="isOnEditMode"
                :value="form.direccionIniciador.formattedAddress"
                :v="$v.form.direccionIniciador.formattedAddress"
              />
              <LmLeaFletMap
                :markerLatLng="markerLatLng"
                :centerMapCoordinate="markerLatLng"
                class="mb-3"
                />
            </div>
          </div>
          <div class="row">
            <div v-if="isOnEditMode" class="col-12 col-lg-6">
              <LmTextInput
                v-model="form.numeroPadron"
                :v="$v.form.numeroPadron"
                label="Nro Padron"
                placeholder="Nro Padron de Comercio"
                :disabled="isOnEditMode"
                />
            </div>
            <div v-else class="col-12 col-lg-4">
              <LmTextInputGroup
                v-model="form.numeroPadronBuscar"
                :v="$v.form.numeroPadronBuscar"
                label="Ingrese el Número o Razón Social a buscar"
                icon="search"
                placeholder="Ingrese el Número o Razón Social a buscar"
                :disabled="isOnEditMode"
                />
            </div>
            <div v-if="!isOnEditMode" class="col-12 col-lg-7">
              <LmSuperPowerSelect
                :data="padronesAsociadosSelectOptions"
                :tbColumns="lmsuperpowerselectTbColumnsCuentas"
                label="Seleccione la Cuenta de Padron a vincular"
                title="Seleccione la Cuenta de Padron a vincular"
                placeholder="Seleccione la Cuenta de Padron a vincular"
                :v="$v.form.numeroPadronSeleccionado"
                @values="updatePadronAsociado"
                :model="form.numeroPadronSeleccionado"
                :disabled="!form.numeroPadronBuscar || isOnEditMode"
              />
            </div>
          </div>
        </div>
        <div v-if="form.codigoTipoIniciador==='AREA'">
          <div class="row">
            <div v-if="!isOnEditMode" class="col-12 col-lg-6">
              <LmSuperPowerSelect
                :data="oficinasSelectOptions"
                :tbColumns="lmsuperpowerselectTbColumnsOficina"
                label="Nombre área interna"
                title="Nombre área interna"
                placeholder="Nombre área interna"
                @values="updateOficinaAreaInterna"
                :v="$v.form.oficinaAreaInterna"
                :model="sanitizeModel(form.idOficinaAreaInterna)"
                :disabled="isOnEditMode"
              />
            </div>
            <div v-else class="col-12 col-lg-6">
              <LmTextInput
                v-model="form.oficinaAreaInterna"
                :v="$v.form.oficinaAreaInterna"
                label="Nombre área interna"
                placeholder="Nombre área interna"
                :disabled="isOnEditMode"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <LmTextInput
                v-model="form.notaAreaInterna"
                :v="$v.form.notaAreaInterna"
                label="Nota Interna"
                placeholder="Número de nota interna"
                :disabled="isOnEditMode"
                :maxLength=40
                />
            </div>
          </div>
        </div>
        <hr>
      </div>
      <h4>Domicilio del trámite</h4>
      <div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <LmSuperPowerSelect
              v-if="!isOnEditMode"
              :data="callesAlturasSelectOptions"
              :tbColumns="lmsuperpowerselectTbColumnsCallesAlturas"
              label="Calle Trámite"
              title="Calle Trámite"
              :v="$v.form.calleTramite"
              :model="form.calleTramite"
              @values="updateCalleAltura"
              :disabled="isOnEditMode"
            />
            <LmTextInput v-else
              v-model="form.calleTramite"
              :v="$v.form.calleTramite"
              label="Calle"
              placeholder="Calle"
              :disabled="isOnEditMode"
              />
          </div>
          <div class="col-12 col-lg-6">
            <LmNumberInput
              v-model="form.alturaTramite"
              :v="$v.form.alturaTramite"
              label="Altura"
              placeholder="Altura"
              :disabled="isOnEditMode"
              />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-6">
            <LmTextInput
              v-model="form.pisoTramite"
              :v="$v.form.pisoTramite"
              label="Piso"
              placeholder="Piso"
              :disabled="isOnEditMode"
              :maxLength=3
              />
          </div>
          <div class="col-12 col-lg-6">
            <LmTextInput
              v-model="form.departamentoTramite"
              :v="$v.form.departamentoTramite"
              label="Departamento"
              placeholder="Departamento"
              :disabled="isOnEditMode"
              :maxLength=3
              />
          </div>
          <div v-if="form.calleTramiteLocation" class="col-12">
            <LmLeaFletMap
              :markerLatLng="markerTramiteLatLng"
              :centerMapCoordinate="markerTramiteLatLng"
              class="mb-3"
              />
          </div>
        </div>
      </div>
      <hr>
      <h4>Trámite a Realizar</h4>
        <div>
          <div v-if="isOnEditMode" class="row">
            <div class="col-12 col-lg-5">
              <LmTextInput
                v-model="form.numeroExpediente"
                :v="$v.form.numeroExpediente"
                label="Expediente"
                placeholder="Número de expediente"
                :disabled="true"
                />
            </div>
            <div class="col-12 col-lg-2">
              <LmTextInput
                v-model="form.anoExpediente"
                :v="$v.form.anoExpediente"
                label="Año"
                placeholder="Año"
                :disabled="true"
                />
            </div>
            <div class="col-12 col-lg-5">
              <LmDate
                v-model="form.fechaAlta"
                :v="$v.form.fechaAlta"
                label="Fecha Alta"
                id="fechaAlta"
                placeholder="Fecha Alta de expediente"
                :disabled="true"
                />
            </div>
          </div>
        </div>
        <div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <LmSuperPowerSelect
                v-if="!isOnEditMode"
                :data="tiposTramitesSelectOptions"
                :tbColumns="lmsuperpowerselectTbColumnsTipoTramite"
                label="Tipo"
                title="Tipo"
                :v="$v.form.tipoTramite"
                @values="updateTipoTramite"
                :model="form.tipoTramite"
                :disabled="isOnEditMode"
              />
              <LmTextInput
                v-else
                v-model="form.tipoTramite"
                label="Tipo"
                :disabled="true"
                />
            </div>
          </div>
          <div class="row">
            <div v-if="!isOnEditMode" class="col-12 col-lg-6">
              <LmSuperPowerSelect
                :data="clasificacionesSelectOptions"
                :tbColumns="lmsuperpowerselectTbColumnsClasificacion"
                label="Clasificación"
                title="clasificación"
                :v="$v.form.clasificacion"
                @values="updateClasificacion"
                :model="sanitizeModel(form.idClasificacion)"
                :disabled="isOnEditMode"
              />
            </div>
            <div v-else class="col-12 col-lg-6">
              <LmTextArea
                v-model="form.clasificacion"
                :v="$v.form.clasificacion"
                :maxLength=4095
                label="Clasificación"
                placeholder="Clasificación"
                :disabled="isOnEditMode"
                />
            </div>
          </div>
          <div class="row">
            <div v-if="!isOnEditMode" class="col-12 col-lg-6">
              <LmSuperPowerSelect
                :disabled="!subclasificacionesSelectOption.length || isOnEditMode"
                :data="subclasificacionesSelectOption"
                :multiple="true"
                :tbColumns="lmsuperpowerselectTbColumnsSubclasificacion"
                label="Subclasificación"
                title="Subclasificación"
                :v="$v.form.subclasificaciones"
                @values="updateSubclasificaciones"
                :model="sanitizeModel(subclasificacionesPreLoad)"
              />
            </div>
            <div v-else class="col-12 col-lg-6">
              <LmTextArea
                v-model="form.subclasificaciones"
                :v="$v.form.subclasificaciones"
                :maxLength=4095
                label="Subclasificación"
                placeholder="Subclasificación"
                :disabled="isOnEditMode"
                />
            </div>
          </div>
        </div>
        <hr>
        <div>
          <div class="row">
            <div class="col-12 col-lg-6">
              <LmTextArea
                v-model="form.observaciones"
                :v="$v.form.observaciones"
                :maxLength=4095
                label="Observaciones"
                placeholder="Observaciones del trámite"
                :disabled="isOnEditMode"
                />
            </div>
          </div>
          <div v-if="form.tipoTramite === 'NOTA' && !isOnEditMode">
            <hr>
            <h4>Agregar a Expediente</h4>
            <div class="row" v-if="!isOnEditMode">
              <div class="col-12 col-lg-4">
                <LmSuperPowerSelect
                  :data="aniosExpedientesAsciadosSelectOptions"
                  :tbColumns="lmsuperpowerselectTbColumnsAniosExpedientesAsciados"
                  label="Seleccione el Año"
                  title="Seleccione el Año"
                  :v="$v.form.anioExpedienteAsociado"
                  @values="updateAnioExpedienteAsociado"
                  :model="form.anioExpedienteAsociado"
                  :disabled="isOnEditMode"
                />
              </div>
              <div class="col-12 col-lg-4">
                <LmTextInputGroup
                  v-model="form.numeroExpedienteAsociado"
                  :v="$v.form.numeroExpedienteAsociado"
                  label="Ingrese el Número de Expediente a buscar"
                  placeholder="Ingrese el Número de Expediente a buscar"
                  :disabled="!form.anioExpedienteAsociado || isOnEditMode"
                  />
              </div>
              <div class="col-12 col-lg-4">
                <LmSuperPowerSelect
                  :data="expedientesAsciadosSelectOptions"
                  :tbColumns="lmsuperpowerselectTbColumnsExpedientesAsciados"
                  label="Seleccione el Expediente"
                  title="Seleccione el Expediente"
                  placeholder="Expedientes encontrados"
                  :v="$v.form.tramiteAsociado"
                  @values="updateTramiteAsociado"
                  :model="form.tramiteAsociado"
                  :disabled="!expedientesAsciadosSelectOptions.length || isOnEditMode"
                />
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-12 col-lg-6">
                <LmTextInput
                  v-model="form.principal"
                  :v="$v.form.principal"
                  :disabled="isOnEditMode"
                  />
              </div>
            </div>
          </div>
          <div v-if="isOnEditMode && form.principal" class="row">
            <div class="col-12 col-lg-6">
              <LmTextInput
                label="Principal"
                v-model="form.principal"
                :disabled="isOnEditMode"
                />
            </div>
          </div>
        </div>
      <div v-if="!isOnEditMode">
        <hr>
        <h4>Pase</h4>
        <div>
          <div class="row">
            <div class="col-12 col-lg-6">
                <LmSuperPowerSelect
                  :data="oficinasSelectOptions"
                  :tbColumns="lmsuperpowerselectTbColumnsOficina"
                  label="Oficina"
                  title="Oficina"
                  placeholder="Oficina de destino"
                  @values="updateIdOficina"
                  :v="$v.form.oficinaDestino"
                  :model="sanitizeModel(form.idOficina)"
                  :disabled="isOnEditMode"
                />
            </div>
          </div>
        </div>
      </div>
      <form
        @submit.prevent="submit"
        novalidate
        class="position-relative">
        <LmButton
          id="btn-go-back"
          v-if="enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click.native="goBackBtn"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
        <LmButton
          id="btn-cancel"
          v-if="!enableGoBackButton"
          type="button"
          buttonClass="btn-secondary"
          :isProcessing="formIsProcessing"
          :value="$t('Cancel')"
          @click.native="cancelBtn"
          lmButtonRootWrapperClass="d-inline-block"
          lmButtonWrapperClass="col"
          />
        <LmButton
          id="btn-submit"
          v-if="!enableGoBackButton"
          type="submit"
          buttonClass="btn-primary"
          :isProcessing="formIsProcessing"
          :value="$t('Save')"
          lmButtonRootWrapperClass="d-inline-block ml-1"
          lmButtonWrapperClass="col"
          />
      </form>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VueScrollTo from 'vue-scrollto'
import { required, numeric, email, requiredIf, minLength, maxLength } from 'vuelidate/lib/validators'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmTextInputGroup from '@/components/form/elements/LmTextInputGroup'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmComponentLoading from '@/components/LmComponentLoading'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import LmGooglePlacesAutocomplete from '@/components/LmGooglePlacesAutocomplete.vue'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'
import commonsApi from '@/api/commons'
import lmExactLength from '@/helpers/lm-exact-length-validator.js'
import lmFormMixin from '@/mixins/lmFormMixin.js'

export default {
  mixins: [lmFormMixin],
  components: {
    LmTextInput,
    LmTextInputGroup,
    LmNumberInput,
    LmEmailInput,
    LmButton,
    LmTextArea,
    LmSelect,
    LmDateTime,
    LmDate,
    LmComponentLoading,
    LmSuperPowerSelect,
    LmGooglePlacesAutocomplete,
    LmLeaFletMap
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      isLoading: true,
      lmsuperpowerselectTbColumnsSubclasificacion: [
        { title: 'Subclasificación', data: 'name' }
      ],
      lmsuperpowerselectTbColumnsCuentas: [
        { title: 'Cuenta', data: 'name' }
      ],
      lmsuperpowerselectTbColumnsAniosExpedientesAsciados: [
        { title: 'Año', data: 'name' },
        { title: '(Cant.)', data: 'count' }
      ],
      lmsuperpowerselectTbColumnsExpedientesAsciados: [
        { title: 'Expediente', data: 'name' },
        { title: 'Iniciador', data: 'iniciador' }
      ],
      lmsuperpowerselectTbColumnsCallesAlturas: [
        { title: 'Calle', data: 'name' }
      ],
      lmsuperpowerselectTbColumnsTipoDocumento: [
        { title: 'Tipo', data: 'name' }
      ],
      lmsuperpowerselectTbColumnsTipoTramite: [
        { title: 'id', data: 'id' },
        { title: 'Tipo', data: 'name' }
      ],
      lmsuperpowerselectTbColumnsClasificacion: [
        { title: 'Clasificación', data: 'name' }
      ],
      lmsuperpowerselectTbColumnsOficina: [
        { title: 'Oficina', data: 'name' }
      ],
      tiposIniciadoresItems: [],
      tiposIniciadores: {
        disabledOption: 'Seleccione el Tipo de Iniciador',
        content: [],
        items: []
      },
      tipoSociedades: {
        disabledOption: 'Seleccione el Tipo de Sociedad',
        content: ['SA', 'SRL', 'SH', 'SAS', 'SAU', 'SCS', 'SCA']
      },
      tipoDocumentos: {
        disabledOption: 'Seleccione el Tipo de Documento',
        content: ['DNI', 'PASAPORTE', 'LC']
      },
      form: this.initializedForm(),
      subclasificacionesSelectOption: [],
      clasificacionesSelectOptions: [],
      oficinasSelectOptions: [],
      tiposTramitesSelectOptions: [],
      aniosExpedientesAsciadosSelectOptions: [],
      expedientesAsciadosSelectOptions: [],
      cuentasAsociadasSelectOptions: [],
      padronesAsociadosSelectOptions: [],
      tiposDocumentosSelectOptions: [],
      tiposSociedadesSelectOptions: [],
      callesAlturasSelectOptions: [],
      formIsProcessing: false
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail']),
    subclasificacionesPreLoad () {
      return Array.isArray(this.form.subclasificaciones) ? this.form.subclasificaciones.map((e) => e.id) : []
    },
    markerLatLng: {
      get () {
        return this.form.direccionIniciador.latLong.length ? this.form.direccionIniciador.latLong : []
      },
      set () {}
    },
    markerTramiteLatLng: {
      get () {
        return this.form.calleTramiteLocation ? this.form.calleTramiteLocation : []
      },
      set () {}
    }
  },
  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    // La uri tanto para obtener la configuracion desde settings como
    // para interactuar con el endpoint que obtiene y persiste los datos
    // para la edicion
    newOrEditEndpointUri: {
      type: String,
      required: true
    },
    isOnEditMode: {
      type: Boolean,
      required: true,
      default: false
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/'
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  validations: {
    form: {
      // Atributos Comunes
      tipoIniciador: {
        required
      },
      calleTramite: {
        required
      },
      alturaTramite: {
        required,
        numeric,
        isValid (value) {
          // Si estamos en modo edicion el este campo temporalmente no se va a validar, ya que por el momento esta
          // desactivada su edicion por una definicion funcional
          if (this.isOnEditMode) {
            return true
          }

          if (value >= this.form.calleTramiteAlturaDesde && value <= this.form.calleTramiteAlturaHasta) {
            if ((this.form.calleTramiteParidad === 'PAR' && (value & 1) === 1) || (this.form.calleTramiteParidad === 'IMPAR' && (value & 1) === 0)) {
              return false
            }

            if (this.form.calleTramite) {
              // eslint-disable-next-line
              const geocoder = new google.maps.Geocoder()
              geocoder.geocode({
                'address': `${this.form.alturaTramite} ${this.form.calleTramiteNombre}, ${this.form.calleTramiteLocalidad}, Buenos Aires, Argentina`
              }, (results, status) => {
                if (status === 'OK') {
                  this.form.calleTramiteLocation = [results[0].geometry.location.lat(), results[0].geometry.location.lng()]
                } else {
                  console.log('No se pudo geolocalizar la direccion del tramite')
                }
              })
            }
            return true
          } else {
            this.form.calleTramiteLocation = []
            return false
          }
        }
      },
      tipoTramite: {
        required
      },
      clasificacion: {
        required
      },
      subclasificaciones: {
        required
      },
      oficinaDestino: {
        required
      },
      // Persona
      tipoDocumento: {
        required: requiredIf(function () {
          return this.form.codigoTipoIniciador === 'PERS'
        })
      },
      numero: {
        required: requiredIf(function () {
          return this.form.codigoTipoIniciador === 'PERS'
        }),
        numeric: numeric,
        minLength: minLength(7),
        maxLength: maxLength(9)
      },
      nombre: {
        required: requiredIf(function () {
          return this.form.codigoTipoIniciador === 'PERS'
        })
      },
      apellido: {
        required: requiredIf(function () {
          return this.form.codigoTipoIniciador === 'PERS'
        })
      },
      emailIniciador: {
        email
      },
      direccionIniciador: {
        formattedAddress: {
          required: requiredIf(function () {
            return this.form.codigoTipoIniciador === 'PERS' || this.form.codigoTipoIniciador === 'COME'
          })
        }
      },
      // Dejo de ser requerido por https://github.com/lumile/mesa-de-entradas/issues/233
      // numeroCuenta: {
      //   required: requiredIf(function () {
      //     return this.form.codigoTipoIniciador === 'PERS'
      //   })
      // },
      // numeroCuentaSeleccionado: {
      //   required: requiredIf(function () {
      //     return this.form.codigoTipoIniciador === 'PERS'
      //   })
      // },
      // Comercio
      tipoSociedad: {
        required: requiredIf(function () {
          return this.form.codigoTipoIniciador === 'COME'
        })
      },
      razonSocial: {
        required: requiredIf(function () {
          return this.form.codigoTipoIniciador === 'COME'
        })
      },
      tipoDocumentoSH: {
      },
      numeroDocumentoSH: {
      },
      nombreSH: {
      },
      apellidoSH: {
      },
      numeroExpediente: {
      },
      anoExpediente: {
      },
      pisoTramite: {
      },
      departamentoTramite: {
      },
      fechaAlta: {
      },
      observaciones: {
      },
      idOficina: {
      },
      pisoIniciador: {
      },
      departamentoIniciador: {
      },
      cuit: {
        required: requiredIf(function () {
          return this.form.codigoTipoIniciador === 'COME'
        }),
        numeric: numeric,
        exactLength: lmExactLength(11)
      },
      // Dejo de ser requerido por https://github.com/lumile/mesa-de-entradas/issues/233
      // numeroPadron: {
      //   required: requiredIf(function () {
      //     return this.form.codigoTipoIniciador === 'COME'
      //   })
      // },
      // numeroPadronSeleccionado: {
      //   required: requiredIf(function () {
      //     return this.form.codigoTipoIniciador === 'COME'
      //   })
      // },
      // Area Interna
      oficinaAreaInterna: {
        required: requiredIf(function () {
          return this.form.codigoTipoIniciador === 'AREA'
        })
      },
      notaAreaInterna: {
        required: requiredIf(function () {
          return this.form.codigoTipoIniciador === 'AREA'
        })
      }
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    async preloadForm () {
      try {
        this.isLoading = true
        await this.loadForm(this.form, {
          path: 'expedientes/activos/edit/',
          id: this.$route.params.id
        })
        const response = await commonsApi.getSelectOptions({
          path: 'codificaciones/tipos_iniciadores/',
          total: 500
        })
        this.tiposIniciadoresItems = response
        this.tiposIniciadores.content = response.map(i => i.name)
        // this.form.codigoTipoIniciador = this.form.tipoIniciador
        // Si se esta en modo edicion se necesita normalizar el combo de tipo iniciador
        // para basado en this.form.codigoTipoIniciador se complete
        // this.form.tipoIniciador con la descripcion larga en vez del ID
        if (this.form.codigoTipoIniciador) {
          this.form.tipoIniciador = this.tiposIniciadoresItems.find(i => i.id === this.form.codigoTipoIniciador).name
        }
      } catch (error) {
        console.log('error: ', error)
        this.$router.replace({ name: '404' })
      } finally {
        this.isLoading = false
      }
    },
    initializedForm () {
      return {
        // Atributos Comunes
        tipoIniciador: 'Área Interna',
        codigoTipoIniciador: 'AREA',
        numeroExpediente: '',
        anoExpediente: '',
        calleTramite: '',
        idCalleTramite: '',
        calleTramiteAlturaDesde: '',
        calleTramiteAlturaHasta: '',
        calleTramiteNombre: '',
        calleTramiteLocalidad: '',
        calleTramiteParidad: '',
        calleTramiteLocation: [],
        alturaTramite: '',
        pisoTramite: '',
        departamentoTramite: '',
        fechaAlta: '',
        tipoTramite: '',
        tipoTramiteDetalle: '',
        clasificacion: '',
        idClasificacion: '',
        subclasificaciones: [],
        observaciones: '',
        // estos 3 campos componen el resultado del campo principal
        anioExpedienteAsociado: '',
        numeroExpedienteAsociado: '',
        tramiteAsociado: '',
        // string compuesto de los 3 campos de arriba
        principal: '',
        // el objeto que identifica al expediente a asociar
        expedienteAsociado: null,
        oficinaDestino: '',
        // Persona
        tipoDocumento: '',
        idTipoDocumento: '',
        numero: '',
        nombre: '',
        apellido: '',
        otros: '',
        emailIniciador: '',
        pisoIniciador: '',
        departamentoIniciador: '',
        numeroCuenta: '',
        numeroCuentaSeleccionado: '',
        // Comercio
        tipoSociedad: '',
        razonSocial: '',
        integrantesSH: [],
        cuit: '',
        numeroPadron: '',
        numeroPadronBuscar: '',
        numeroPadronSeleccionado: '',
        // Area Interna
        idOficinaAreaInterna: '',
        oficinaAreaInterna: '',
        notaAreaInterna: '',
        direccionIniciador: {
          latLong: [],
          formattedAddress: ''
        }
      }
    },
    showToastFormError () {
      this.$bvToast.toast('El formulario contiene errores', {
        title: 'Error',
        toaster: 'b-toaster-bottom-center',
        variant: 'danger',
        solid: true
      })
    },
    errorScrollTo () {
      VueScrollTo.scrollTo('#form', 1000)
    },
    inputLmGooglePlacesAutocomplete (value) {
      if (!value) {
        this.markerLatLng = []
        this.form.direccionIniciador.latLong = []
        this.form.direccionIniciador.formattedAddress = ''
      }
    },
    updateSubclasificaciones (data) {
      this.form.subclasificaciones = data.map(e => {
        return { id: e.id, name: e.name }
      })
    },
    placeChanged (place) {
      const latLong = [
        place.geometry.location.lat(),
        place.geometry.location.lng()
      ]
      this.markerLatLng = latLong
      this.form.direccionIniciador.latLong = latLong
      this.form.direccionIniciador.formattedAddress = place.formatted_address
    },
    goBackBtn () {
      this.$router.go(-1)
    },
    agregarIntegrante () {
      this.form.integrantesSH.push({
        tipoDocumentoSH: null,
        numeroDocumentoSH: null,
        nombreSH: null,
        apellidoSH: null
      })
    },
    borrarIntegrantesSH (index, integrantesSH) {
      if (index >= 1) {
        integrantesSH.splice(index, 1)
      }
    },
    cancelBtn () {
      if (this.$v.form.$invalid) {
        this.$router.push(this.onSuccessDestinationRoute)
      } else {
        if (confirm(this.$t('cancel_msg'))) {
          this.$router.push(this.onSuccessDestinationRoute)
        }
      }
    },
    sanitizeModel (model) {
      return model ? model.toString() : ''
    },
    submit () {
      this.$v.form.$touch()
      if (this.$v.form.$error) {
        this.showToastFormError()
        this.errorScrollTo()
      }
      if (!this.$v.form.$pending && !this.$v.form.$error) {
        this.formIsProcessing = true
        /**
         * Se persisten los datos
         */
        let data = this.form
        data.id = this.$route.params.id
        let insertAttributes = {
          tipoOperacion: 'alta-normal',
          tipoIniciador: this.form.codigoTipoIniciador,
          idCalleTramite: this.form.idCalleTramite,
          calleTramite: this.form.calleTramiteNombre,
          alturaTramite: this.form.alturaTramite,
          pisoTramite: this.form.pisoTramite,
          calleTramiteLocation: this.form.calleTramiteLocation,
          departamentoTramite: this.form.departamentoTramite,
          fechaAlta: this.form.fechaAlta,
          tipoTramite: this.form.tipoTramite,
          tipoTramiteDetalle: this.form.tipoTramiteDetalle,
          idClasificacion: this.form.idClasificacion,
          clasificacion: this.form.clasificacion,
          observaciones: this.form.observaciones,
          principal: this.form.principal,
          idOficina: this.form.idOficina,
          oficina: this.form.oficinaDestino
        }
        if (this.form.expedienteAsociado !== null) {
          insertAttributes.expedienteAsociado = this.form.expedienteAsociado
        }
        if (this.form.subclasificaciones.length) {
          insertAttributes.subclasificaciones = JSON.stringify(this.form.subclasificaciones)
        }
        if (this.form.codigoTipoIniciador === 'PERS') {
          insertAttributes.tipoDocumento = this.form.tipoDocumento
          insertAttributes.idTipoDocumento = this.form.idTipoDocumento
          insertAttributes.numero = this.form.numero
          insertAttributes.nombre = this.form.nombre
          insertAttributes.apellido = this.form.apellido
          insertAttributes.emailIniciador = this.form.emailIniciador
          insertAttributes.direccionIniciador = this.form.direccionIniciador
          insertAttributes.pisoIniciador = this.form.pisoIniciador
          insertAttributes.departamentoIniciador = this.form.departamentoIniciador
          insertAttributes.numeroCuenta = this.form.numeroCuenta
        } else if (this.form.codigoTipoIniciador === 'COME') {
          insertAttributes.tipoSociedad = this.form.tipoSociedad
          insertAttributes.razonSocial = this.form.razonSocial
          insertAttributes.cuit = this.form.cuit
          insertAttributes.numeroPadron = this.form.numeroPadron
          insertAttributes.emailIniciador = this.form.emailIniciador
          insertAttributes.direccionIniciador = this.form.direccionIniciador
          if (this.form.tipoSociedad === 'SH') {
            insertAttributes.integrantesSH = JSON.stringify(this.form.integrantesSH)
          }
        } else if (this.form.codigoTipoIniciador === 'AREA') {
          insertAttributes.idOficinaAreaInterna = this.form.idOficinaAreaInterna
          insertAttributes.oficinaAreaInterna = this.form.oficinaAreaInterna
          insertAttributes.notaAreaInterna = this.form.notaAreaInterna
        }
        this.updateItemDetail({
          path: 'expedientes/new/',
          data: insertAttributes
        })
          .then(() => {
            this.formIsProcessing = false
            this.$router.push(this.onSuccessDestinationRoute)
          })
          .catch(error => {
            console.log(error)
            this.formIsProcessing = false
          })
      } else {
        console.log('no se envio')
      }
    },
    updateClasificacion (value) {
      if (value.length) {
        this.form.idClasificacion = value[0].id
        this.form.clasificacion = value[0].name
      } else {
        this.subclasificacionesSelectOption = []
      }
    },
    updateIdOficina (value) {
      if (value.length) {
        this.form.oficinaDestino = value[0].name
        this.form.idOficina = value[0].id
      } else {
        this.form.oficinaDestino = ''
        this.form.idOficina = ''
      }
    },
    updateOficinaAreaInterna (value) {
      if (value.length) {
        this.form.oficinaAreaInterna = value[0].name
        this.form.idOficinaAreaInterna = value[0].id
      } else {
        this.form.oficinaAreaInterna = ''
        this.form.idOficinaAreaInterna = ''
      }
    },
    updateTipoTramite (value) {
      if (value.length) {
        this.form.tipoTramite = value[0].id
        this.form.tipoTramiteDetalle = value[0].name
      } else {
        this.form.tipoTramite = ''
        this.form.tipoTramiteDetalle = ''
      }
    },
    updateTipoDocumento (value) {
      if (value.length) {
        this.form.idTipoDocumento = value[0].id
        this.form.tipoDocumento = value[0].name
      } else {
        this.form.idTipoDocumento = ''
        this.form.tipoDocumento = ''
      }
    },
    updateTipoSociedad (value) {
      if (value.length) {
        this.form.tipoSociedad = value[0].id
      } else {
        this.form.tipoSociedad = ''
      }
    },
    updateAnioExpedienteAsociado (value) {
      if (value.length) {
        this.form.anioExpedienteAsociado = value[0].name
      } else {
        this.form.anioExpedienteAsociado = ''
      }
    },
    updateTramiteAsociado (value) {
      if (value.length) {
        this.form.tramiteAsociado = value[0].name
        this.form.expedienteAsociado = {
          anioExpedienteAsociado: this.form.anioExpedienteAsociado,
          numeroExpedienteAsociado: value[0].numero_expediente,
          tipoTramiteAsociado: value[0].codigo_tipo_expediente
        }
        this.form.principal = value[0].name
      } else {
        this.form.tramiteAsociado = ''
        this.form.expedienteAsociado = null
        this.form.principal = ''
      }
    },
    updateCuentaAsociada (value) {
      if (value.length) {
        this.form.numeroCuenta = value[0].id
        this.form.numeroCuentaSeleccionado = value[0].name
      } else {
        this.form.numeroCuenta = ''
        this.form.numeroCuentaSeleccionado = ''
      }
    },
    updatePadronAsociado (value) {
      if (value.length) {
        this.form.numeroPadron = value[0].id
        this.form.numeroPadronSeleccionado = value[0].name
      } else {
        this.form.numeroPadron = ''
        this.form.numeroPadronSeleccionado = ''
      }
    },
    updateTipoIniciador (value) {
      this.form.codigoTipoIniciador = this.tiposIniciadoresItems.find(i => i.name === value).id
    },
    updateCalleAltura  (value) {
      if (value.length) {
        this.form.idCalleTramite = value[0].c_calle
        this.form.calleTramite = value[0].name
        this.form.calleTramiteAlturaDesde = value[0].desde
        this.form.calleTramiteAlturaHasta = value[0].hasta
        this.form.calleTramiteNombre = value[0].calle
        this.form.calleTramiteLocalidad = value[0].localidad
        this.form.calleTramiteParidad = value[0].paridad
      } else {
        this.form.idCalleTramite = ''
        this.form.calleTramite = ''
        this.form.calleTramiteAlturaDesde = ''
        this.form.calleTramiteAlturaHasta = ''
        this.form.calleTramiteNombre = ''
        this.form.calleTramiteLocalidad = ''
        this.form.calleTramiteParidad = ''
      }
    }
  },
  watch: {
    isOnEditMode () {
      if (this.isOnEditMode) {
        this.preloadForm()
      } else {
        this.form = this.initializedForm()
        this.subclasificacionesSelectOption = []
      }
    },
    'form.idClasificacion' () {
      if (this.form.idClasificacion) {
        commonsApi.getSelectOptions({
          path: 'subclasificaciones/predictivo/',
          parentId: this.form.idClasificacion,
          total: 500
        })
          .then(response => {
            this.subclasificacionesSelectOption = response
          })
          .catch(error => {
            console.log('error: ', error)
          })
      }
    },
    'form.anioExpedienteAsociado' () {
      this.form.numeroExpedienteAsociado = ''
      if (!this.isOnEditMode) {
        this.form.principal = ''
      }
    },
    'form.numeroExpedienteAsociado' () {
      if (this.form.numeroExpedienteAsociado.length > 2) {
        commonsApi.getSelectOptions({
          path: 'expedientes/potenciales_padres/',
          id: this.form.numeroExpedienteAsociado,
          year: this.form.anioExpedienteAsociado,
          total: 50
        })
          .then(response => {
            this.expedientesAsciadosSelectOptions = response
          })
          .catch(error => {
            console.log(error)
            this.expedientesAsciadosSelectOptions = []
          })
      } else {
        this.expedientesAsciadosSelectOptions = []
      }
    },
    'form.numeroCuentaBuscar' () {
      if (this.form.numeroCuentaBuscar.length >= 2) {
        commonsApi.getSelectOptions({
          path: 'cuentas/buscar/',
          term: this.form.numeroCuentaBuscar,
          total: 10
        })
          .then(response => {
            this.cuentasAsociadasSelectOptions = response
          })
          .catch(error => {
            console.log(error)
            this.cuentasAsociadasSelectOptions = []
          })
      } else {
        this.cuentasAsociadasSelectOptions = []
      }
    },
    'form.numeroPadronBuscar' () {
      if (this.form.numeroPadronBuscar && this.form.numeroPadronBuscar.length >= 2) {
        commonsApi.getSelectOptions({
          path: 'padron/buscar/',
          term: this.form.numeroPadronBuscar,
          total: 10
        })
          .then(response => {
            this.padronesAsociadosSelectOptions = response
          })
          .catch(error => {
            console.log(error)
            this.padronesAsociadosSelectOptions = []
          })
      } else {
        this.padronesAsociadosSelectOptions = []
      }
    }
  },
  created () {
    if (this.isOnEditMode) {
      // Se está en modo edicion, es necesario precargar los datos desde el formulario
      // desde el mixin
      this.preloadForm()
    } else {
      commonsApi.getSelectOptions({
        path: 'codificaciones/tipos_iniciadores/',
        total: 500
      })
        .then(response => {
          this.tiposIniciadoresItems = response
          this.tiposIniciadores.content = response.map(i => i.name)
          this.isLoading = false
        })
        .catch(error => {
          console.log('error: ', error)
        })
    }

    commonsApi.getSelectOptions({
      path: 'clasificaciones/predictivo/',
      total: 500
    })
      .then(response => {
        this.clasificacionesSelectOptions = response
      })
      .catch(error => {
        console.log('error: ', error)
      })

    commonsApi.getSelectOptions({
      path: 'oficinas/predictivo/',
      total: 1000
    })
      .then(response => {
        this.oficinasSelectOptions = response
      })
      .catch(error => {
        console.log('error: ', error)
      })

    commonsApi.getSelectOptions({
      path: 'codificaciones/tipos_expedientes/',
      total: 1000
    })
      .then(response => {
        this.tiposTramitesSelectOptions = response
      })
      .catch(error => {
        console.log('error: ', error)
      })

    commonsApi.getSelectOptions({
      path: 'expedientes/por_anios/'
    })
      .then(response => {
        this.aniosExpedientesAsciadosSelectOptions = response
      })
      .catch(error => {
        console.log('error: ', error)
      })

    commonsApi.getSelectOptions({
      path: 'codificaciones/tipos_documentos/',
      total: 1000
    })
      .then(response => {
        this.tiposDocumentosSelectOptions = response
      })
      .catch(error => {
        console.log('error: ', error)
      })

    commonsApi.getSelectOptions({
      path: 'codificaciones/tipos_sociedades/',
      total: 1000
    })
      .then(response => {
        this.tiposSociedadesSelectOptions = response
      })
      .catch(error => {
        console.log('error: ', error)
      })

    commonsApi.getSelectOptions({
      path: 'callesalturas/todos/',
      total: 1000
    })
      .then(response => {
        this.callesAlturasSelectOptions = response
      })
      .catch(error => {
        console.log('error: ', error)
      })
  }
}
</script>

<style lang="sass" scoped>
  hr
    border-top: 2px solid !important
    margin-top: 50px !important
    margin-bottom: 20px !important
  h4, h5
    margin-bottom: 30px !important
</style>
